import { useApi } from './use-api-call';

export interface LicenseActivationReportDTO {
    serial: number;
    licenseCode?: string;
    licenseKey: string;
    batchNumber?: string;
    productId: number;
    isDelivered: boolean;
    deliveredAt?: string;
    deliveredToUserName?: string;
}

export interface BatchSummaryDTO {
    batchNumber: string;
    totalCount: number;
    activatedCount: number;
    notActivatedCount: number;
}

export interface LicenseActivationReportResult {
    licenses: LicenseActivationReportDTO[];
    products: Array<{ id: number; name: string }>;
    batchNumbers: string[];
    totalCount: number;
    activatedCount: number;
    notActivatedCount: number;
    pageSize: number;
    pageIndex: number;
}

export interface BatchSummaryResult {
    batchSummary: BatchSummaryDTO[];
}

export interface LicenseActivationReportFilter {
    productId?: number;
    batchNumber?: string;
    isDelivered?: boolean;
    pageSize?: number;
    pageIndex?: number;
}

export const useLicenseActivationReportApi = () =>
    useApi<LicenseActivationReportResult>('/reports/license-activation-report');

export const useBatchSummaryApi = () =>
    useApi<BatchSummaryResult>('/reports/batch-summary');

